import clsx from 'clsx';
import React, {
  ReactElement, Suspense, useEffect, useState
} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button } from '@/components/button/button';
import { Loader } from '@/components/loader/loader';
import { useAuthContext } from '@/hooks/useAuthContext';
import { parseParams } from '@/utils/searchParams';

type SearchParams = {
  code?: string;
  error?: string;
  error_description?: string;
  state?: string;
};

function Auth0CallbackPage() {
  const navigate = useNavigate();
  const { tokenExchange } = useAuthContext();

  /* DATA */
  const [ searchParams ] = useSearchParams();
  const {
    code: qCode,
    error: qError,
    error_description: qErrorDescription,
    state: qState
  } = parseParams<SearchParams>( searchParams );

  const [ error, setError ] = useState<string | undefined>( undefined );
  const [ isLoading, setIsLoading ] = useState<boolean>( true );

  useEffect( () => {
    ( async() => {
      try {
        // Handle Auth0 errors
        if( qError ) {
          throw Error( `Auth failed: ${ qError }.  ${ qErrorDescription }` );
        }

        if( !qCode || !qState ) {
          throw Error( 'missing params' );
        }

        // exchange for token
        await tokenExchange( {
          code: qCode,
          state: qState
        } );
      } catch( e ) {
        console.error( 'Callback error:', e );
        setError( 'An unexpected error occurred during authentication' );
      } finally {
        setIsLoading( false );
      }
    } )();
  }, [ qCode, qError, qErrorDescription, qState, tokenExchange ] );

  const ErrorEl = (): ReactElement => (
    <>
      <div className={ clsx( 'layout__row', 'pad' ) }>
        <h3>Authentication Error</h3>
      </div>
      <div className='layout__error'>
        { error }
      </div>
      <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
        <Button
          variant='primary'
          onClick={ () => navigate( '/login' ) }
        >
          Back to Login
        </Button>
      </div>
    </>
  );

  return (
    <div className={ clsx( 'page', 'center_xy' ) }>
      <div className='auth_flow_container'>
        {
          isLoading && <Loader />
        }
        {
          error && <ErrorEl />
        }
      </div>
    </div>
  );
}

export default function Page() {
  return (
    <Suspense fallback={ <Loader /> }>
      <Auth0CallbackPage />
    </Suspense>
  );
}
